import styled from "styled-components";

const VideoContainer = styled.object`
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  max-height: 600px;
  border-radius: ${(props) => (props.radius ? "8px" : "0")};
  overflow: hidden;
`;

export { VideoContainer };
